import React, { useState } from 'react';

import { RoleType } from '@modules/core/models';

interface Props {
    accessRoles: RoleType[];
    children: any;
    exact?: boolean;
}

export const RoleRestriction = (props: Props) => {
    const { children } = props;
    const [isVisible] = useState<boolean>(true);

    /* useEffect(() => {
        const visible = userStore.isAccessable(accessRoles, exact);
        setIsVisible(visible);
    }, [accessRoles, exact, userStore, userStore.roles]); */

    return isVisible ? <>{children}</> : null;
};
